/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import React from 'react';
import queryString from 'query-string';
import { Redirect, useHistory } from 'react-router-dom';
import NotFound from '@g17eco/atoms/not-found';
import { handleRouteError } from '../../logger';
import { useAppSelector } from '../../reducers';
import { SettingStorage } from '../../services/SettingStorage';
import { CustomAttributes, getOrgConfiguration, getRoute } from './util';
import { Loader } from '@g17eco/atoms/loader';
import { useOktaAuth } from '@okta/okta-react';


export const RedirectRoute = () => {

  const history = useHistory();
  const { loaded, data: rootInitiatives } = useAppSelector((state) => state.rootInitiatives);
  const queries = queryString.parse(history.location.search) as unknown as CustomAttributes;

  const { oktaAuth, authState } = useOktaAuth();

  if (!authState?.isAuthenticated) {
    oktaAuth.signInWithRedirect({ originalUri: history.location.pathname + history.location.search })
    return <Loader />; // Loading... so it doesn't fall back to <Route component={NotFound} />}
  }
  if (!loaded) {
    return <Loader />;
  }

  try {
    const { rootAppPath, storageKey, orgId } = getOrgConfiguration(rootInitiatives, queries);
    if (orgId) {
      SettingStorage.setItem(storageKey, orgId)
    }
    const url = getRoute(queries, rootAppPath)
    return <Redirect to={url} />;
  } catch (e) {
    handleRouteError(e, queries as any)
  }

  return <NotFound />;
}
